import { useEffect, useState, type FormEvent } from 'react';
import type { CompanyRequisites } from '@kassa/shared';
import { api, ApiError } from '../../api';

// Şirkət rekvizitləri (KT-95): çek və qaimədə satıcı — ad, VÖEN, ünvan; qaimə və müqavilə üçün rəhbər, bank.
const FIELDS: { key: keyof CompanyRequisites; label: string; hint?: string }[] = [
  { key: 'name', label: 'Hüquqi ad' },
  { key: 'voen', label: 'VÖEN', hint: '10 rəqəm' },
  { key: 'address', label: 'Ünvan' },
  { key: 'director', label: 'Rəhbər' },
  { key: 'phone', label: 'Telefon' },
  { key: 'bankName', label: 'Bank' },
  { key: 'bankAccount', label: 'Hesab (IBAN)' },
];

export function CompanyPanel() {
  const [form, setForm] = useState<CompanyRequisites | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .companyRequisites()
      .then(setForm)
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : 'Rekvizitlər yüklənmədi'));
  }, []);

  async function save(e: FormEvent) {
    e.preventDefault();
    if (!form) return;
    setBusy(true);
    setError(null);
    setSaved(false);
    try {
      setForm(await api.companyRequisitesSave(form));
      setSaved(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Saxlanmadı');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="card" aria-label="Şirkət rekvizitləri">
      <h2>Şirkət rekvizitləri</h2>
      <p className="muted small">Çekdə və qaimədə satıcı kimi yazılır.</p>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      {!form && !error && <p className="muted">Yüklənir…</p>}
      {form && (
        <form className="form-grid" onSubmit={save}>
          {FIELDS.map((f) => (
            <label key={f.key} className="field">
              {f.label}
              <input
                value={form[f.key] ?? ''}
                inputMode={f.key === 'voen' ? 'numeric' : undefined}
                placeholder={f.hint}
                onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
                required={f.key === 'name'}
                disabled={busy}
              />
            </label>
          ))}
          <button type="submit" className="btn-primary" disabled={busy}>
            Rekvizitləri saxla
          </button>
          {saved && (
            <p className="ok" role="status">
              Saxlanıldı.
            </p>
          )}
        </form>
      )}
    </section>
  );
}
